module.exports = {
    language: {
        name: 'en'
    },
    banner: {
        more: "Slide More",
    },
    img: {
        logo: 'logo',
        company: 'company',
        code: 'code',
        xcxercode: 'xcxercode',
        totop: 'totop',
    },
    nav: {
        companyName: 'Zhexin Siwei',
        nav1: "Home",
        nav2: 'About Us',
        nav3: 'Cases',
        nav4: 'News',
        nav5: 'Business',
    },
    headline: {
        title1: 'Core Technologies',
        title2: 'Application Scenarios',
        title3: 'Success Cases',
        title4: 'About the Company',
        title5: 'Core Team',
        title6: 'Contact Us',
        title7: 'Partner'
    },
    technology: {
        title1: "Affective Large Model Interaction, Empathy Capability",
        content1: 'Capture 26-dimensional emotional features in speech and build an interactive system with "empathy ability"',
        title2: "Real-time response",
        content2: 'The self-developed large model achieves millisecond-level response, enabling rapid processing of user speech. It optimizes camera performance through a dynamic frame rate adjustment algorithm, controlling the system response delay within 500 milliseconds (compared to the industry average of 2-3 seconds) and supporting offline voice interaction.',
        title3: "Voiceprint recognition",
        content3: `"A 'human-like' interactive dialogue experience with character voiceprint recognition functionality, intelligently distinguishing between different conversational characters and accurately identifying user identities."`,
        title4: "Memory capacity",
        content4: `It has a long-term memory function and can remember users' preferences, habits, and key historical information in communication.`,
        title5: "Hybrid computing architecture",
        content5: `Local processing handles low-latency tasks (such as wake-up word detection), while complex reasoning (such as long text analysis) is entrusted to cloud-based large models, achieving a balance between power consumption and performance.`,
        title6: "Environmental noise reduction",
        content6: 'Microphone array noise reduction ensures a recognition accuracy of over 95% even in complex environments.',
    },
    scenarios: {
        title1: 'Smart education',
        content1: 'Integrate innovative educational resources to build an intelligent classroom system, providing teachers and students with personalized learning experiences and an intelligent teaching management platform (including projectors, microscopes, eye-protection lamps, recognition machines, printers, and speakers).',
        title2: 'Smart elderly care',
        content2: 'Provide smart elderly care solutions, including services such as remote health monitoring, intelligent care systems, and social platforms for the elderly (monitoring, chatting, wheelchairs, nursing beds, blood glucose meters, oxygen concentrators, learning machines, toilets, anti-loss devices, medicine boxes).',
        title3: 'Intelligent toys',
        content3: 'Develop intelligent interactive toy products, integrating AR/VR technologies to provide children with safe and interesting intelligent entertainment experiences (including plush toys, robots, electric vehicles, IP images, and peripheral economy).',
        title4: 'Smart sports',
        content4: 'Develop a professional sports data analysis system that provides intelligent training programs and real-time performance monitoring solutions (running companions, body fat scales, Smart Track, Style AI Mascot).',
        title5: 'Smart wearables',
        content5: 'Create a new generation of smart wearable devices that integrate health monitoring, sports tracking, and life assistant functions (earphones, neck-hung fans, sun hats with fans, watches, glasses, schoolbags).',
        title6: 'Smart home appliances',
        content6: 'Provide a whole-house smart home appliance solution to realize intelligent control and energy-saving management of home life (air conditioners, fans, lighting, coffee machines, rice cookers).',
    },
    cases: {
        title1: 'Upgrading of smart home appliance products',
        device1: 'Large appliances',
        content1: 'By implanting our self-developed AI module, the intelligent air conditioner has been comprehensively upgraded, significantly enhancing user experience and product competitiveness.',
        msg11: 'Supports the MCP protocol, endowing AI with the ability to use tools.',
        msg12: 'User behavior learning, with an accuracy rate of 95% in intelligent scene configuration.',
        msg13: 'Remote intelligent control with a response time of less than 500ms.',
        title2: 'Smart home fan solution',
        device2: 'Smart home appliances',
        content2: 'Implanting an AI control module into the fan products enables advanced functions such as intelligent adjustment and remote control, with product sales increasing by 65%.',
        msg21: 'Natural language + semantic understanding',
        msg22: 'User satisfaction has increased by 80%.',
        msg23: 'Multi-scenario linkage, supporting smart home ecosystem.',
        title3: 'Innovation in intelligent toys',
        device3: 'Toy tank, teddy bear doll',
        content3: `Implant AI interaction chips into a variety of children's toy products to create a new category of intelligent toys that can learn, think and accompany.`,
        msg31: 'Intelligent voice interaction with a recognition accuracy rate of 98%',
        msg32: `Personalized learning system, with children's learning interest increased by 75%`,
        msg33: 'Emotional interaction system, with a parental recommendation rate of 92%',
    },
    introduction: {
        p1: 'Zhexin Siwei is an innovative enterprise focusing on artificial intelligence (AI), founded by a team of PhDs jointly trained by Zhejiang University and Singapore Management University. The team specializes in the research and development of software and hardware for end-side intelligent agents based on multimodal human-like AI emotional large models, as well as the application of such technologies in various vertical industries.',
        p2: `The company focuses on the R&D of Xiaozhi AI (a multimodal emotional model with the Emotional Model at its core) and embedded software and hardware. This system features multimodal recognition, personalized emotional expression, and long-term memory capabilities. Equipped with an MCP (Modular Capability Platform) for scalable AI functions, it integrates speech recognition, NLP (Natural Language Processing), and speech synthesis technologies to enable natural conversations.`,
        p3: 'By optimizing the real-time performance and realism of interactions, it delivers a companionship experience characterized by high emotional intelligence and rapid responsiveness, infusing technology with greater warmth.',
        p4: 'It is widely applicable to various fields and scenarios that require human-computer interaction, and is currently mainly used in the sports industry, smart home sector, and embodied robotics industry. Zhexin Siwei is committed to expanding the computing capabilities of emotional large models to more application scenarios, enabling technology to be not only intelligent but also more warm.',
        p5: 'Elite talents',
        p6: 'Technical patents',
        p7: 'Corporate clients',
    },
    founders: {
        name1: 'Dr. Qin Bing',
        job1: 'Founder & Actual Controller',
        titles1: `Department of Physics, Sichuan University, EMBA<br>Senior Engineer & Senior Economist<br>Changxing City Member of the CPPCC<br>Chairman of Changxing Botai Electronics Group`,
        name2: `Dr. Tan Xue`,
        job2: `Co-founder & CEO`,
        titles2: `Former senior executive of a Fortune Global 500 foreign enterprise<br>20 years of experience in the FMCG industry<br>Responsible for the overall operation of the company`,
        name3: `Cai Meihang`,
        job3: `Head of R&D (Research and Development)`,
        titles3: `Sichuan University, Electronic Information<br>Possess 13 domestically authorized patents<br>2 U.S. patents<br>Deeply engaged in smart device AIoT`,
        name4: `Huang Guan (Xia Ge)`,
        job4: `Chief Strategic Advisor`,
        titles4: `Chairman of Shifang Ronghai<br>Department of Computer Science, South China University of Technology<br>"Domain Expert" of Shenzhen Software Industry, 2022<br>2024 China Artificial Intelligence Outstanding Person Award<br>Provide technical support for multimodal large models`,

    },
    contactUs: {
        title1: "Company Information",
        content11: 'Address',
        content12: 'Telephone',
        content13: 'Email',
        content14: 'Room 904, Building C5, Phase II, Zhejiang University Alumni Enterprise Headquarters Economic Park, Yuhang District, Hangzhou City, Zhejiang Province',
        content15: '（WeChat same number）',
        title2: 'Policy Services',
        content21: "Copyright Notice",
        content22: "Complaint",
        content23: "User Agreement",
        content24: "Privacy Policy",
        content25: "After-sales Service",
        content26: "About Us",
        title3: 'WeChat Official Account',
        title4: 'WeChat Mini Program',
        title5: 'Zhexin Siwei Technology Co. Ltd',
        title6: 'All rights reserved',
        title7: 'Zhejiang ICP Bei 2025182597-1',
        title8: 'Follow us'
    },
    bannerTxt: {
        title1: "latest updates",
        msg1: `Show the company's latest events, news and honors`,
        title2: "Contact Us",
        msg2: 'Please let us know your requirements, and our professional consultants will contact you as soon as possible.',
    },
    news: {
        title1: `Zhexin Siwei and Lingjing Zhiyuan Reach Strategic Cooperation to Jointly Drive New Breakthroughs in Domestic Embodied Intelligence`,
        date1: `October 27, 2025, 16:24`,
        title2: `Breaking News: Zhexin Siwei Secures Seed Round Funding to Fully Layout the Entire AI Industry Chain`,
        date2: `October 14, 2025, 11:15`,
        title3: `"Zhexin Siwei" Makes an Appearance at the 6th Zhejiang Provincial Outdoor Sports Conference`,
        date3: `September 17, 2025, 17:19`,
        title4: `Zhexin Siwei Shines at the 2025 Bund Conference: Empowering Industrial Transformation with AI Innovation`,
        date4: `September 16, 2025, 16:19`,
        title5: `"Zhe Xiaoti" and "Yu Dazui" will make their appearances at the Zhejiang City Basketball League Championship (Zhe BA).`,
        date5: `August 13, 2025, 15:22`,
    },
}